// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__EbSmlescWyGqV","footer":"footer__xuidQdN-Q7VTG"};